import CaladreTheme from "theme/Theme";
import AuthBackgroundImage from "assets/images/main-background.png";
import sharedStyle from "../style";

const classes = {
  ...sharedStyle,
  authContainer: {
    backgroundImage: `url(${AuthBackgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center, center",
    minHeight: "calc(100vh - 80px)",
    display: "flex",
    justifyContent: "center",
    paddingTop: "50px",
    paddingBottom: "50px",
    "& .MuiTab-root": {
      borderTopLeftRadius: "15px",
      borderTopRightRadius: "15px",
      textTransform: "initial",
      fontWeight: "bold",
      fontSize: "16px",
      color: CaladreTheme.custom.White,
      backgroundColor: CaladreTheme.palette.secondary.main,
      "&:nth-of-type(even)": {
        backgroundColor: CaladreTheme.palette.primary.main,
      },
      "&.Mui-selected": {
        border: "1px solid white",
        color: CaladreTheme.palette.primary.main,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
      },
    },
    "& .MuiCardContent-root": {
      maxWidth: "40vw",
      padding: CaladreTheme.spacing(6, 3),
    },
    "& .MuiCardContent-root > .MuiButton-root": {
      display: "flex",
      justifyContent: "start",
      width: "100%",
      margin: CaladreTheme.spacing(1.5, 0),
      padding: CaladreTheme.spacing(1.5, 10, 1.5, 3),
      border: "none",
      fontFamily: "PoppinsRegular",
      color: "black",
      borderRadius: "12px",
      backgroundColor: CaladreTheme.custom.Gray,
      "&:hover": {
        border: "none",
        color: "black",
        backgroundColor: CaladreTheme.custom.Gray,
      },
    },
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      marginRight: "8px",
    },
  },
};
export default classes;
